module.exports = __webpack_public_path__ + "media/images/payment-history-dc2d8448.svg";